import React from "react";
import { Modal, Button } from "react-bootstrap";

const GrievanceModal = ({ show, onHide }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      dialogClassName="grievance-modal"
    >
      <Modal.Header closeButton className="border-0 bg-gradient">
        <Modal.Title className="text-white">
          Grievance Redressal Mechanism
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <section style={{ lineHeight: "1.6" }}>
          <h5>1. How to log in a complaint / where can a complaint be made</h5>
          <p>
            Any customer having a grievance/complaint/feedback with respect to
            the product and services offered by InCred Financial Services
            Limited may write to the Customer Service Department via:
          </p>
          <ul>
            <li>Call: <b>18001022192</b></li>
            <li>Email: <b>care@incred.com</b></li>
            <li>
              Letter: Unit No. 1203, 12th floor, B Wing, The Capital, Plot No.
              C-70, G Block, Bandra-Kurla Complex, Mumbai - 400051
            </li>
            <li>Website: <b>www.incred.com</b></li>
          </ul>

          <h5>2. Whom to approach for redressal</h5>
          <p>
            Customers are requested to first raise their concerns through any of
            the above channels. If unresolved within 5 days, follow these
            escalations:
          </p>
          <ul>
            <li>
              <b>Ms. Rosy Dsouza</b> <br />
              Contact: 022-42117799 <br />
              Email: care@incred.com
            </li>
            <li>
              If still unresolved, approach the <b>Grievance Redressal Officer</b>: <br />
              Name: Mr. Vaidyanathan Ramamoorthy <br />
              Email: incred.grievance@incred.com <br />
              Telephone: 022-42117799
            </li>
          </ul>

          <h5>3. Details of InCred Personal Loan</h5>
          <p>
            Details of InCred Personal loans can be found at{" "}
            <a
              href="https://personal-loans.incred.com/personal-loan"
              target="_blank"
              rel="noreferrer"
            >
              https://personal-loans.incred.com/personal-loan
            </a>
          </p>
        </section>
      </Modal.Body>
      <Modal.Footer className="border-0">
        <Button variant="gradient" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>

      <style jsx>{`
        .grievance-modal .modal-content {
          border-radius: 15px;
          background: linear-gradient(145deg, #f7f7f7, #e2e2e2);
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
        }
        .grievance-modal .modal-header.bg-gradient {
          background: linear-gradient(90deg, #4caf50, #2e7d32);
          border-top-left-radius: 15px;
          border-top-right-radius: 15px;
        }
        .grievance-modal .btn-gradient {
          background: linear-gradient(90deg, #4caf50, #2e7d32);
          color: #fff;
          border: none;
        }
        .grievance-modal .btn-gradient:hover {
          background: linear-gradient(90deg, #66bb6a, #1b5e20);
        }
      `}</style>
    </Modal>
  );
};

export default GrievanceModal;
